import { render, staticRenderFns } from "./Department.vue?vue&type=template&id=33f40e37&scoped=true"
import script from "./Department.vue?vue&type=script&lang=js"
export * from "./Department.vue?vue&type=script&lang=js"
import style0 from "./Department.vue?vue&type=style&index=0&id=33f40e37&prod&scoped=true&lang=css"
import style1 from "./Department.vue?vue&type=style&index=1&id=33f40e37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f40e37",
  null
  
)

export default component.exports